import tabeeLogo from '../../tabee/logo.svg'

import c from './style.module.css'

export function TabeeLogo ({ className = '' }: { className?: string }) {
    return (
        <img alt="Tabee logo" className={`${c.img} ${className}`} src={tabeeLogo} />
    )
}
